export const STAKING_WALLET_TYPE = "staking";
export const EARNING_WALLET_TYPE = "earning";

export const STAKING_WALLET_COPY = {
  tabLabel: "Airdrop Earning Wallet",
  assetLabel: "Airdrop Earning Asset",
  balanceLabel: "Airdrop Earning Wallet Balance",
  helper: "Referral rewards. Use only to buy staking packages. Cannot transfer or withdraw.",
  banner: "This balance can only be used to purchase staking packages.",
  subscribeLabel: "Airdrop Earning Wallet",
  subscribeSubtitle: "Referral release funds",
  emptyBalance: "0.00 — wait for round release, or buy with Main if allowed",
  transferBlocked: "Staking wallet cannot be transferred. It can only be used to purchase staking packages.",
};

export const FALLBACK_WALLET_TYPES = [
  "main",
  "spot",
  // "p2p",
  "futures",
  "swap",
  "earning",
  "staking",
];

export const ACCOUNT_TYPE_META = {
  main: { label: "Main", className: "" },
  spot: { label: "Spot", className: "spot" },
  p2p: { label: "P2P", className: "p2p" },
  futures: { label: "Futures", className: "futures" },
  swap: { label: "Swap", className: "swap" },
  earning: { label: "Earning", className: "earning" },
  staking: { label: "Staking", className: "staking" },
};

export const isStakingWallet = (type) =>
  String(type || "").toLowerCase() === STAKING_WALLET_TYPE;

export const isP2pWallet = (type) => String(type || "").toLowerCase() === "p2p";

export const isTransferableWallet = (type) => !isStakingWallet(type) && !isP2pWallet(type);

export const filterTransferableWallets = (types = []) =>
  (types || []).filter(isTransferableWallet);

const capitalize = (str) => {
  if (typeof str !== "string" || !str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/** Assets sidebar / wallet tab label */
export const getAssetsWalletLabel = (type) => {
  if (isStakingWallet(type)) return STAKING_WALLET_COPY.tabLabel;
  if (!type) return "Wallet";
  return `${capitalize(type)} Wallet`;
};

/** Subscribe dropdown label */
export const getSubscribeWalletLabel = (type) => {
  if (isStakingWallet(type)) return STAKING_WALLET_COPY.subscribeLabel;
  return capitalize(type) || "Wallet";
};

export const getAccountTypeMeta = (type) => {
  const key = String(type || "").toLowerCase();
  return (
    ACCOUNT_TYPE_META[key] || {
      label: capitalize(key) || "Wallet",
      className: key,
    }
  );
};

export const getAccountTypesFromWallets = (types = []) => {
  const list = types?.length ? types : FALLBACK_WALLET_TYPES;
  return list.map((key) => {
    const meta = getAccountTypeMeta(key);
    return { key, label: meta.label, className: meta.className };
  });
};
